import {
  REQUEST_DAYS_OFF,
  RECEIVE_DAYS_OFF,
} from '../constants';
import config from '../../config';
import { checkStatus } from '../utils/helpers';

const requestDaysOff = id => ({
  type: REQUEST_DAYS_OFF,
  payload: id,
});

const receiveDaysOff = payload => ({
  type: RECEIVE_DAYS_OFF,
  payload,
});

export const fetchDaysOff = (barber) => {
  const id = barber.get('id');
  return (dispatch) => {
    dispatch(requestDaysOff(id));
    const url = `${config.url}/barber/${id}/days-off`;
    return fetch(url)
      .then(checkStatus)
      .then(daysOff => dispatch(receiveDaysOff(daysOff)));
  };
};

export default fetchDaysOff;



// WEBPACK FOOTER //
// ./src/app/daysOff/actions.js